export default {"src":"/polygon/_next/static/media/qidao.df852911.svg","height":48,"width":48};